export default __webpack_public_path__ + "static/media/pic_5.8112388d.JPG";